import React from "react";
import { CheckCircle2 } from "lucide-react";
import { company } from "../../mock";

const points = [
  "Nearly three decades of uninterrupted production at Vapi GIDC",
  "Dedicated QC lab with titration, AAS & spectrophotometry",
  "Multi-grade capability — C.P., L.R. and A.R. Grade pure acids",
  "Manufacturer, Supplier & Repacker — approved by PSUs, defence & large infrastructure projects"
];


const About = () => {
  return (
    <section id="about" className="py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-5 lg:px-6 grid lg:grid-cols-12 gap-10 lg:gap-12 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="relative pb-10 lg:pb-0 pr-2 lg:pr-0">
            <div className="absolute -top-4 -left-4 sm:-top-6 sm:-left-6 h-24 w-24 sm:h-32 sm:w-32 rounded-2xl brand-band opacity-20" />
            <img
              src="https://images.pexels.com/photos/10666081/pexels-photo-10666081.jpeg?w=900"
              alt="Acid manufacturing plant with industrial piping"
              className="relative rounded-2xl border border-slate-200 shadow-xl shadow-slate-200/60 w-full h-[300px] sm:h-[380px] lg:h-[440px] object-cover"
            />
            <div className="absolute -bottom-2 right-2 sm:-bottom-6 sm:-right-6 bg-white rounded-2xl shadow-xl border border-slate-200 p-4 sm:p-5 max-w-[180px] sm:max-w-[220px]">
              <div className="font-display font-extrabold text-[28px] sm:text-[34px] text-slate-900 leading-none">20,000<span className="text-teal-700">+</span></div>
              <div className="text-[11.5px] sm:text-[12.5px] text-slate-500 mt-1 font-medium">Metric Tonnes dispatched every year</div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2">
          <div className="text-[12px] uppercase tracking-[0.22em] font-semibold text-teal-700">About {company.name}</div>
          <h2 className="mt-3 font-display font-extrabold text-slate-900 text-[34px] lg:text-[44px] leading-[1.1]">
            A 27-year legacy of <span className="text-gradient-brand">pure, consistent</span> industrial chemistry
          </h2>
          <p className="mt-5 text-slate-600 text-[16px] leading-relaxed">
            Established in {company.established} as a proprietorship and now a private limited company, {company.name} is a <strong className="text-slate-800">Manufacturer, Supplier &amp; Repacker</strong> of pure acids in <strong className="text-slate-800">C.P., L.R. and A.R. grades</strong>. From our Vapi GIDC unit we manufacture and pack five core inorganic chemicals that power India’s pharma, textile, steel, paper and water-treatment industries.
          </p>
          <p className="mt-4 text-slate-600 text-[16px] leading-relaxed">
            Our growth has been driven by long-term client partnerships — over 70% of our annual volume is contracted with customers we have served for more than a decade.
          </p>

          <ul className="mt-7 grid sm:grid-cols-2 gap-3">
            {points.map((p, i) => (
              <li key={i} className="flex items-start gap-3 bg-slate-50 border border-slate-200 rounded-lg p-3.5">
                <CheckCircle2 className="h-5 w-5 text-teal-700 mt-0.5 shrink-0" />
                <span className="text-[14.5px] text-slate-700 font-medium">{p}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default About;
